/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, Button, Layout, Dropdown, Drawer } from 'antd';
import TemplateLink from './components/TemplateLink';
import TemplatePreview from './components/TemplatePreview';
import TemplateListCard from './components/TemplateListCard';
import { useNavigate } from 'react-router-dom';
import { ROUTER } from '../../../../constants/router';
import IconNoData from '../../../../assets/Images/icons/icon-no-data';
import GlobalService from '../../../../services/Global.service';
import TemplateDesignService from '../../../../services/TemplateDesign.service';
import DownloadFile from './components/DownloadFile';
import HistoryDrawer from './components/TemplateHistory/HistoryDrawer';
import { CloseOutlined, EyeOutlined } from '@ant-design/icons';
import IconWaring from '../../../../assets/Images/icons/icon-waring';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import ModalDelete from '../../../../components/Shared/modal/delete';
import useNotify from '../../../../context/Notification/useNotify';
import usePermission from '../../../../hooks/usePermission';

const TemplateList = () => {
    const { t, i18n } = useTranslation('consent');
    const lang = i18n?.language;
    let navigate = useNavigate();
    const notify = useNotify();

    const [previewLang, setPreviewLang] = useState('th');
    const [searchValue, setSearchValue] = useState();
    const [searchTemplateCategory, setSearchTemplateCategory] = useState();
    const [dataTotal, setDataTotal] = useState();
    const [templateList, setTemplateList] = useState();
    const [currentSelectList, setCurrentSelectList] = useState([]);
    const [masterConsent, setMasterConsent] = useState([]);
    const [masterTerm, setMasterTerm] = useState([]);
    const [templateType, setTemplateType] = useState('');

    const [templateDetail, setTemplateDetail] = useState();
    const [templateDetailPublish, setTemplateDetailPublish] = useState();

    const [logo, setLogo] = useState('');
    const [logoPublish, setLogoPublish] = useState('');

    // Delete Consent
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [dataObject, setDataObject] = useState(null);

    const searchConsentList = async (value) => {
        if (!value) {
            value = {
                p: 1,
                ps: 10,
                s: 'modifyDate',
                sd: 'desc',
            };
        }
        try {
            const { data } = await TemplateDesignService.searchTemplateDesign(
                value
            );
            if (data?.resultData) {
                setTemplateList(data?.resultData.result);
                const currentSelectList = data?.resultData.result[0];
                await setCurrentSelectList(currentSelectList);
                await setTemplateType(currentSelectList?.templateType);
                await setDataTotal(data?.resultData.total);
                if (currentSelectList?.templateKey) {
                    if (currentSelectList?.templateType === 'Consent')
                        getConsentDetail(currentSelectList?.templateKey);
                    else getTermConditionDetail(currentSelectList?.templateKey);
                }
                if (
                    currentSelectList?.hasChanged &&
                    currentSelectList?.status === 'Published'
                )
                    if (currentSelectList?.templateType === 'Consent')
                        getConsentDetailPublisher(
                            currentSelectList?.templateKey
                        );
                    else
                        getTermConditionDetailPublish(
                            currentSelectList?.templateKey
                        );
                else setTemplateDetailPublish();
                // setShow(true)
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getImage = async (companyLogoId) => {
        try {
            const { data } = await GlobalService.getImage(companyLogoId);
            if (data.resultData?.imageId) {
                return `data:image/png;base64,${data.resultData?.imageId}`;
            } else {
                setLogo('');
                setLogoPublish('');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getConsentDetailPublisher = async (key) => {
        try {
            const { data } =
                await TemplateDesignService.getTemplateConsentPublish(key);
            if (data?.resultData) {
                const item = data?.resultData;
                setLogoPublish('');
                if (item?.logoId) {
                    getImage(item?.logoId).then((logo) => setLogoPublish(logo));
                }
                await setTemplateDetailPublish(item);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getConsentDetail = async (value) => {
        try {
            const { data } = await TemplateDesignService.getTemplateConsent(
                value
            );
            if (data?.resultData) {
                const item = data?.resultData;
                setLogo('');
                if (item?.logoId) {
                    getImage(item?.logoId).then((logo) => setLogo(logo));
                }
                await setTemplateDetail(item);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getTermConditionDetailPublish = async (value) => {
        try {
            const { data } =
                await TemplateDesignService.getTemplateTermAndConditionPublish(
                    value
                );
            if (data?.resultData) {
                const item = data?.resultData;
                setLogoPublish('');
                if (item?.logoId) {
                    getImage(item?.logoId).then((logo) => setLogoPublish(logo));
                }
                await setTemplateDetailPublish(item);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getTermConditionDetail = async (value) => {
        try {
            const { data } =
                await TemplateDesignService.getTemplateTermAndCondition(value);
            if (data?.resultData) {
                const item = data?.resultData;
                setLogo('');
                if (item?.logoId) {
                    getImage(item?.logoId).then((logo) => setLogo(logo));
                }
                await setTemplateDetail(item);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getMasterConsent = async () => {
        try {
            const { data } = await TemplateDesignService.getConsentPublished({
                consentType: 'Consent',
            });
            if (data?.resultData) {
                setMasterConsent(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getMasterTerm = async () => {
        try {
            const { data } = await TemplateDesignService.getConsentPublished({
                consentType: 'TermCondition',
            });
            if (data?.resultData) {
                setMasterTerm(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        getMasterConsent();
        getMasterTerm();
    }, [searchValue]);

    const menu = () => (
        <Menu
            className="w-full"
            items={[
                {
                    className: 'hover:bg-[#EEE5FF] py-3',
                    label: t('Consent Template'),
                    key: '1',
                    onClick: () => {
                        navigate(
                            `${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}/consent/add`
                        );
                    },
                },
                {
                    className: 'hover:bg-[#EEE5FF] py-3',
                    label: t('Term & Condition Template'),
                    key: '2',
                    onClick: () => {
                        navigate(
                            `${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}/term&condition/add`
                        );
                    },
                },
            ]}
        />
    );

    const [visibleHistories, setVisibleHistories] = useState(false);
    const [isChangeStatus, setIsChangeStatus] = useState(true);

    useEffect(() => {
        if (currentSelectList?.templateKey) {
            if (currentSelectList?.templateType === 'Consent')
                getConsentDetail(currentSelectList?.templateKey);
            else getTermConditionDetail(currentSelectList?.templateKey);
        }
        if (
            currentSelectList?.hasChanged &&
            currentSelectList?.status === 'Published'
        )
            if (currentSelectList?.templateType === 'Consent')
                getConsentDetailPublisher(currentSelectList?.templateKey);
            else getTermConditionDetailPublish(currentSelectList?.templateKey);
        else setTemplateDetailPublish();
    }, [currentSelectList]);

    const onViewApiDocument = () => {
        window.open('https://coda.io/d/_dpU8vfjfmIv/6-Acceptance-Daily_suIrL');
    };

    const { isAuditor } = usePermission();

    return (
        <>
            <div>
                <div className="title ">Template Design</div>
                <div className="sub-title">
                    <span className="text-sm text-gray-400">
                        {t('ConsentManagement')} /
                    </span>
                    <span> Template Design </span>
                </div>
            </div>

            <Layout>
                <div className="flex items-center my-4">
                    <div className="flex-1 font-bold text-xl">
                        {t('TemplateList')}
                    </div>
                    <div className="space-x-2">
                        <Button
                            disabled={isAuditor}
                            onClick={onViewApiDocument}
                            icon={<EyeOutlined />}
                            className="px-6 text-tiny border-purple text-purple"
                            size="large"
                        >
                            API Document
                        </Button>
                        <Dropdown
                            disabled={isAuditor}
                            overlay={menu()}
                            trigger={['click']}
                            overlayStyle={{ width: '240px' }}
                            placement="bottomRight"
                        >
                            {/* active:bg-[#7B67FB] focus:bg-[#7B67FB] */}
                            <Button
                                className="w-[150px] text-tiny hover:bg-[#7B67FB]"
                                type="primary"
                                size="large"
                            >
                                + {t('Add Template')}
                            </Button>
                        </Dropdown>
                    </div>
                </div>
                <div className="grid grid-cols-7 gap-4">
                    <TemplateListCard
                        templateList={templateList}
                        setCurrentSelectList={setCurrentSelectList}
                        currentSelectList={currentSelectList}
                        setSearchValue={setSearchValue}
                        searchConsentList={searchConsentList}
                        setSearchTemplateCategory={setSearchTemplateCategory}
                        searchTemplateCategory={searchTemplateCategory}
                        dataTotal={dataTotal}
                        setConfirmDelete={setConfirmDelete}
                        setOpenDelete={setOpenDelete}
                        setDataObject={setDataObject}
                        setTemplateType={setTemplateType}
                        templateType={templateType}
                        getImage={getImage}
                        setTemplateDetail={setTemplateDetail}
                    />
                    {templateList?.length > 0 ? (
                        <div className="w-full col-span-5 flex flex-col space-y-4">
                            {!isAuditor && (
                                <TemplateLink
                                    previewLang={previewLang}
                                    detail={currentSelectList}
                                    setVisibleHistories={setVisibleHistories}
                                    setIsChangeStatus={setIsChangeStatus}
                                />
                            )}
                            <TemplatePreview
                                setPreviewLang={setPreviewLang}
                                previewLang={previewLang}
                                templateSelect={currentSelectList}
                                templateDetail={templateDetail}
                                templateDetailPublish={templateDetailPublish}
                                logo={logo}
                                logoPublish={logoPublish}
                                masterConsent={masterConsent}
                                masterTerm={masterTerm}
                                templateType={templateType}
                            />
                            <DownloadFile
                                masterConsent={masterConsent}
                                masterTerm={masterTerm}
                                templateType={templateType}
                                logo={logo}
                                logoPublish={logoPublish}
                                templateDetail={templateDetail}
                                templateDetailPublish={templateDetailPublish}
                            />
                        </div>
                    ) : (
                        <div className="w-full col-span-5 flex flex-col space-y-4 bg-white rounded-t-md shadow-sm">
                            <div className="text-center text-sm space-y-2 my-64">
                                <IconNoData />
                                <p className="text-[#65707A] text-[14px] whitespace-pre-line">
                                    {lang === 'en' ? (
                                        <>
                                            {' '}
                                            You can add your Template consent
                                            and terms & conditions <br />
                                            by pressing the{' '}
                                            <span className="font-semibold">
                                                “Add Template“
                                            </span>{' '}
                                            button."
                                        </>
                                    ) : (
                                        <>
                                            คุณสามารถเพิ่ม Template consent และ
                                            Terms & conditions <br />
                                            โดยกดปุ่ม{' '}
                                            <span className="font-semibold">
                                                “เพิ่ม Template“
                                            </span>
                                        </>
                                    )}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </Layout>
            <Drawer
                // width={520}
                title={
                    <div className="flex justify-between items-center">
                        <span className="text-purple text-[17px]">
                            {t('History')}
                        </span>
                        <button
                            onClick={(e) => {
                                setVisibleHistories(false);
                            }}
                            className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm font-semibold"
                        >
                            <CloseOutlined />
                        </button>
                    </div>
                }
                placement="right"
                onClose={() => setVisibleHistories(false)}
                closable={false}
                open={visibleHistories}
                className="history"
            >
                <HistoryDrawer
                    templateKey={currentSelectList?.templateKey}
                    setIsChangeStatus={setIsChangeStatus}
                    isChangeStatus={isChangeStatus}
                />
            </Drawer>
            <ModalDelete
                loading={loadingDelete}
                open={openDelete}
                title={
                    dataObject?.status === 'Draft'
                        ? t('ModalTitleDeleteDraft')
                        : t('ModalTitleDeleteDraft')
                }
                text={
                    dataObject?.status === 'Draft'
                        ? `${t('ModalDeleteDraft', {
                              version: dataObject?.version,
                          })}`
                        : `${t('ModalDetailDeletePublish')} \n${t(
                              'ModalDeletePublish',
                              { version: dataObject?.latestPublishVersion }
                          )}`
                }
                handelOk={async () => {
                    try {
                        setLoadingDelete(true);
                        const { data } =
                            await TemplateDesignService.deleteTemplate(
                                dataObject?.templateKey
                            );
                        if (data?.resultCode === 1) {
                            setOpenDelete(false);
                            setLoadingDelete(false);
                            notify({
                                title: t('Success'),
                                description: t('Successfully deleted data'),
                            });
                            console.log('searchValue', searchValue);
                            searchConsentList(searchValue);
                        } else {
                            setOpenDelete(false);
                            setLoadingDelete(false);
                            notify({
                                type: 'error',
                                title: t('Fail'),
                                description: t('FailedDeleteData'),
                                timeOut: 120000,
                                closeable: true,
                            });
                        }
                    } catch (err) {
                        setOpenDelete(false);
                        setLoadingDelete(false);
                        notify({
                            type: 'error',
                            title: t('Fail'),
                            description: t('FailedDeleteData'),
                            timeOut: 120000,
                            closeable: true,
                        });
                    }
                }}
                handelClose={() => {
                    setOpenDelete(false);
                }}
            />
            <ModalConfirm
                open={confirmDelete}
                title={
                    lang === 'en'
                        ? 'Some applications \nmay require this template.'
                        : 'บางแอปพลิเคชันอาจมีการเชื่อมต่อกับ \nTemplate รายการนี้อยู่'
                }
                text={
                    lang === 'en'
                        ? `Please check that no system uses the \n"Template Key" of this data before deleting it.`
                        : `โปรดตรวจสอบว่าไม่มีระบบใดใช้ "Template Key" \nของข้อมูลนี้ก่อนที่จะลบ`
                }
                confirmText={t('CheckConfirm')}
                handelOk={() => {
                    setConfirmDelete(false);
                    setOpenDelete(true);
                }}
                handelClose={() => {
                    setConfirmDelete(false);
                }}
                icon={<IconWaring />}
            />
        </>
    );
};

export default TemplateList;
